import { AxiosResponse } from "axios";
import axiosInstance from "../../../api/axios";

export const signupUser = async (
  values: any,
  file: any,
  isSponsored: boolean
) => {
  const formData = new FormData();
  formData.append("first_name", values.firstname);
  formData.append("middle_name", values.middlename);
  formData.append("last_name", values.lastname);
  formData.append("sex", values.sex);
  if (isSponsored) {
    formData.append("facility_id", values.facility);
  }
  formData.append("position", values.position);
  formData.append("is_facility_admin", isSponsored.toString());
  formData.append("password", values.password);
  formData.append("email", values.email);
  formData.append("role_id", "0");
  formData.append("phone_number", values.phonenumber);
  if (file) {
    formData.append("document", file);
  }
  try {
    const response: AxiosResponse<any> = await axiosInstance.post(
      "/user",
      formData
    );
    return {
      data: response.data,
      success: true
    };
  } catch (error: any) {
    // Handle failure (e.g., show an error message)
    return {
      data: error.response?.data,
      success: false,
    };
  }
};
